import { AccountRole } from "../graphql";

export const config = [
  {
    key: 10,
    label: "calls.shortTitle",
    to: "/home",
    role: [AccountRole.Doctor, AccountRole.MedicalSpecialist],
  },
  {
    key: 20,
    label: "Telefonata",
    role: [AccountRole.Admin],
    subpaths: [
      {
        id: 21,
        to: "/calls/overview",
        label: "Në linjë",
      },
      {
        id: 22,
        to: "/calls/all",
        label: "Historiku",
      },
    ],
  },
  {
    key: 30,
    label: "Blog",
    role: [AccountRole.Admin, AccountRole.Author],
    subpaths: [
      {
        id: 31,
        label: "Artikuj",
        to: "/articles",
      },
      {
        id: 32,
        label: "Reklama",
        to: "/ads",
      },
    ],
  },
  {
    key: 40,
    label: "patients.shortTitle",
    to: "/patients",
    role: [AccountRole.Doctor, AccountRole.MedicalSpecialist],
  },
  {
    key: 50,
    label: "Evente",
    to: "/events",
    role: [AccountRole.Admin],
  },
  {
    key: 60,
    label: "Bllokmedia",
    to: "/stories",
    role: [AccountRole.Admin, AccountRole.Author],
  },
  {
    key: 70,
    label: "events.shortTitle",
    to: "/hosted-events",
    role: [AccountRole.Doctor, AccountRole.MedicalSpecialist],
  },
  {
    key: 80,
    label: "Përdoruesit",
    role: [AccountRole.Admin],
    subpaths: [
      {
        id: 81,
        to: "/requests",
        label: "Aplikime për mjek",
      },
      {
        id: 82,
        to: "/clients",
        label: "Klientë",
      },
      {
        id: 83,
        to: "/doctors",
        label: "Mjekë",
      },
      {
        id: 84,
        to: "/specialists",
        label: "Specialistë",
      },
      {
        id: 85,
        to: "/authors",
        label: "Autorë",
      },
      {
        id: 86,
        to: "/admins",
        label: "Administratorë",
      },
    ],
  },
  {
    key: 90,
    label: "Abonime",
    role: [AccountRole.Admin],
    subpaths: [
      {
        id: 91,
        to: "/subscriptions",
        label: "Historiku",
      },
      {
        id: 92,
        to: "/subscriptions/need-review",
        label: ["Kërkojnë aprovim"],
      },
    ],
  },
  {
    key: 100,
    label: "Raporte",
    role: [AccountRole.Admin],
    subpaths: [
      {
        id: 101,
        to: "/report/calls",
        label: "Telefonata",
      },
      {
        id: 102,
        to: "/report/calls-by-doctor",
        label: "Telefonata sipas mjekëve",
      },
      {
        id: 103,
        to: "/report/subscriptions",
        label: "Abonime",
      },
      {
        id: 104,
        to: "/report/medical-cards-by-concern",
        label: "Vizita sipas simptomave",
      },
    ],
  },
  {
    key: 110,
    label: "Konfigurime",
    role: [AccountRole.Admin],
    subpaths: [
      {
        id: 111,
        to: "/countries",
        label: "Shtete",
      },
      {
        id: 112,
        to: "/cities",
        label: "Qytete",
      },
      {
        id: 113,
        to: "/health-centers",
        label: "Qëndra shëndetsore",
      },
      {
        id: 114,
        to: "/insurance-policies",
        label: "Polica sigurimi",
      },
      {
        id: 115,
        to: "/specialities",
        label: "Specialitete",
      },
      {
        id: 116,
        label: "Paketa",
        to: "/tiers",
      },
      {
        id: 117,
        label: "Përfitime",
        to: "/benefits",
      },
      {
        id: 118,
        label: "Karta",
        to: "/cards",
      },
      {
        id: 119,
        label: "Pyetje dhe përgjigje",
        to: "/faqs",
      },
      {
        id: 120,
        to: "/medical-concerns",
        label: "Lista e simptomave",
      },
    ],
  },
  {
    key: 130,
    label: "Njofto globalisht",
    to: "/notify-all",
    role: [AccountRole.Admin],
  },
];
